export const text = {
  reportCategory: "Report Category",
};
